import dayjs from 'dayjs';

const normalizeDate = (date, isEndDate = false) => {
  const adjustedDate = isEndDate ? dayjs(Number(date)).subtract(1, 'day') : dayjs(Number(date));
  return adjustedDate.format('DD MMM YYYY');
};

export default normalizeDate;
